import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LiteralsTranslationService } from '@uipath/workflow-web-viewer';

@Injectable()
export class NugetViewerTranslationService extends LiteralsTranslationService {
    constructor(public translateService: TranslateService) {
        super();
    }

    getValue = (literalKey: string): string => {
        const value = this.translateService.instant(literalKey);
        if (value === literalKey) {
            return super.getValue(literalKey);
        }

        return value;
    }
}
